import { Box, CircularProgress, Container, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

let desc = '';
let dia = true;
class ConsultaMovimientosFuncionarios extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            consulta: false,

            busqueda: {
                consulta: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                codigo: '',
                ubicacionBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: '',
                ubicacionCentral: '',
                codEspeciales: true,
                anioBusqueda: '',
            },

            codigosMovimientos: [],
            numeroNombre: [],
            lugaresTra: [],
            ubicacionesCentral: [],
            consultaRealizada: [],
        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);

    }

    async componentDidMount(){

        const fech = new Date();
        this.setState({
            actual: fech.toISOString().substring(8,10) + '/' + fech.toISOString().substring(5,7) + '/' + fech.toISOString().substring(0,4)
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado['hastaBusqueda'] = fech.toISOString().substring(0,10);
            numFunActualizado['anioBusqueda'] = fech.toISOString().substring(0,4);
            return{
                busqueda: numFunActualizado,
            };
        });

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_codigosMovimientos.php`);
        const datos = await respuesta.json();
        this.setState({
            codigosMovimientos: datos,
        });

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });

        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });
    }


    render(){
        return (
            <>
                <h3>Consulta Movimientos</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                <div>
                {this.state.consulta ?
                    <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                    </ReactHtmlTableToExcel>
                :
                    null
                }
                </div>
                <br/>
                {this.state.consulta
                ?
                    null
                :
                    <Container>
                        <TableContainer style={{width: '90%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell width={'16%'}>Consulta</StyledTableCell>
                                        <StyledTableCell width={'16%'}>Número Funcionario</StyledTableCell>
                                        <StyledTableCell width={'16%'}>Nombre</StyledTableCell>
                                        <StyledTableCell width={'16%'}>Ubicación</StyledTableCell>
                                        {this.state.busqueda.ubicacionBusqueda === '0' ? <StyledTableCell width={'16%'}>Ubicación Central</StyledTableCell> : null}
                                        <StyledTableCell width={'16%'}>Desde</StyledTableCell>
                                        <StyledTableCell width={'16%'}>Hasta</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <StyledTableRow>
                                        <StyledTableCell>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambiosDatos}>
                                                <option value=''></option>
                                                {this.state.codigosMovimientos.map((name) =>
                                                    <option
                                                    key={name.idCodigoMovimiento}
                                                    value={name.idCodigoMovimiento}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.busqueda.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell>{this.state.busqueda.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionBusqueda'  value={this.state.busqueda.ubicacionBusqueda} onChange={this.manejarCambiosDatos}>
                                                <option value=''>UBICACION</option>
                                                {this.state.lugaresTra.map((name) =>
                                                    <option
                                                    key={name.idLugaresTrabajo}
                                                    value={name.idLugaresTrabajo}
                                                    >{name.lugar}</option>
                                                    )}
                                            </select>
                                        </StyledTableCell>
                                        {this.state.busqueda.ubicacionBusqueda === '0' ?
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.busqueda.ubicacionCentral} onChange={this.manejarCambiosDatos}>
                                                    <option value=''>UBICACION</option>
                                                    {this.state.ubicacionesCentral.map((name) =>
                                                        <option
                                                        key={name.idUbicacionesCentral}
                                                        value={name.idUbicacionesCentral}
                                                        >{name.descripcion}
                                                    </option>
                                                        )}
                                                </select>
                                            </StyledTableCell> : null
                                        }
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desdeBusqueda' value={this.state.busqueda.desdeBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='hastaBusqueda' value={this.state.busqueda.hastaBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <button style={{marginTop: '1rem'}} className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button>
                    </Container>
                }
                {this.state.consulta
                ?
                    <Container>
                        <TableContainer style={{width: '90%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        {/*<StyledTableCell width={'16%'}>Consulta</StyledTableCell>*/}
                                        <StyledTableCell width={'16%'}>Consulta</StyledTableCell>
                                        <StyledTableCell width={'16%'}>Número</StyledTableCell>
                                        <StyledTableCell width={'16%'}>Nombre</StyledTableCell>
                                        <StyledTableCell width={'16%'}>Desde</StyledTableCell>
                                        <StyledTableCell width={'16%'}>Hasta</StyledTableCell>
                                        <StyledTableCell width={'16%'}>Días/Minutos</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.consultaRealizada.map((dato) => (
                                            <StyledTableRow key={dato.idMovimiento}>
                                                <StyledTableCell>{dato.descripcion}</StyledTableCell>
                                                <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{dato.desde}</StyledTableCell>
                                                <StyledTableCell>{dato.hasta}</StyledTableCell>
                                                <StyledTableCell>{dato.duracion}</StyledTableCell>
                                        </StyledTableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {this.state.consulta ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : null }
                    </Container>
                :
                    null
                }
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            if((clave === 'numeroFuncionario') && (valor !== '') ){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }else if((clave === 'nombreFuncionario') && (valor === '')){
                numFunActualizado['nombreFuncionario'] = '';
            }

            if(clave === 'ubicacionBusqueda'){
                if(valor !== '0'){
                    numFunActualizado['ubicacionCentral'] = '';
                }
            }
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(){
        this.setState({
            errores: null,
            loading: true,
        });
        //Realizo la consulta
        const cargaUtil = JSON.stringify([this.state.busqueda]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_movimientosFuncionarios.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        this.setState({
            loading: false,
            errores: exito[0],
            notificaciones: null,
        })

        //----------------------------------
        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                consulta: true,
                consultaRealizada: exito[1],
            })
        }
        //----------------------------------
        /*if(exito.length !== 0){
            if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES TODOS LOS FUNCIONARIOS',
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' TODOS LOS FUNCIONARIOS',
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda,
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS TODOS LOS FUNCIONARIOS UBICACION ' + ubi + ' ' + ubiCentral,
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS TODOS LOS FUNCIONARIOS DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda,
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' TODOS LOS FUNCIONARIOS UBICACION ' + ubi + ' ' + ubiCentral,
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' TODOS LOS FUNCIONARIOS DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' UBICACION ' + ubi + ' ' + ubiCentral,
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' UBICACION ' + ubi + ' ' + ubiCentral + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda == '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' UBICACION ' + ubi + ' ' + ubiCentral,
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' UBICACION ' + ubi + ' ' + ubiCentral + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES TODOS LOS FUNCIONARIOS UBICACION ' + ubi + ' ' + ubiCentral + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo == '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS GENERALES FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda == '') && (this.state.busqueda.ubicacionBusqueda != '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' TODOS LOS FUNCIONARIOS' + ' UBICACION ' + ubi + ' ' + ubiCentral + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }else if((this.state.busqueda.codigo != '') && (this.state.busqueda.numeroFuncionarioBusqueda != '') && (this.state.busqueda.ubicacionBusqueda == '') && (this.state.busqueda.desdeBusqueda != '')){
                this.setState({
                    tipoEncabezado: 'LISTADO MOVIMIENTOS ' + tipC + ' FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda + ' DESDE ' + this.state.busqueda.desdeBusqueda.substring(8,10) + "/" + this.state.busqueda.desdeBusqueda.substring(5,7) + "/" + this.state.busqueda.desdeBusqueda.substring(0,4) + ' HASTA ' + this.state.busqueda.hastaBusqueda.substring(8,10) + "/" + this.state.busqueda.hastaBusqueda.substring(5,7) + "/" + this.state.busqueda.hastaBusqueda.substring(0,4),
                });
            }
            this.setState({
                consultaRealizada: exito,
                errores: null,
                notificaciones: null,
                consulta: true,
                //resCodEspecial: true,
            });
            if((this.state.busqueda.codigo === '1000') || (this.state.busqueda.codigo === '1001') || (this.state.busqueda.codigo === '1002') || (this.state.busqueda.codigo === '1003') || (this.state.busqueda.codigo === '1004')){
                this.setState({
                    resCodEspecial: true,
                });
            }
        }else{
            const fech = new Date();
            this.setState({
                resCodEspecial: false,
                anio: false,
                consulta: false,
                consultaRealizada: [],
                errores: 'No hay datos para la consulta realizada!',
                busqueda: {
                    consulta: '',
                    numeroFuncionarioBusqueda: '',
                    codigo: '',
                    ubicacionBusqueda: '',
                    desdeBusqueda: '',
                    hastaBusqueda: fech.toISOString().substring(0,10),
                    ubicacionCentral: '',
                    codEspeciales: true,
                    anioBusqueda: fech.toISOString().substring(0,4),
                },
            });
        }*/
    }

    manejarAtras(e){
        e.preventDefault();
        const fech = new Date();
        this.setState({
            consulta: false,
            anio: false,
            consultaRealizada: [],
            errores: null,
            notificaciones: null,
            resCodEspecial: false,
            busqueda: {
                consulta: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                codigo: '',
                ubicacionBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: fech.toISOString().substring(0,10),
                ubicacionCentral: '',
                codEspeciales: true,
                anioBusqueda: '',
            },
        });
    }

}

export default ConsultaMovimientosFuncionarios